export const Colors: string[] = [
  '#fcefde',
  '#d9e8f2',
  '#f7d3cb',
  '#d9bb99',
  '#b595fe',
  '#ffc3dd',
  // '#010c54',
  // '#6b7280',
];
